import React, { Component } from 'react';
import { Button, Confirm, Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ProjectsTable from '../components/ProjectsTable';
import { getProjectsList } from '../data/actions';
import { deleteProject } from '../scenes/singleProject/data/projectActions';
import ProjectsPagination from '../components/ProjectsPagination';

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleteConfirmOpen: false,
      projectIdToDelete: null,
      projectNameToDelete: ''
    };

    this.openDeleteConfirm = this.openDeleteConfirm.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
    this.handleDeleteCancel = this.handleDeleteCancel.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(getProjectsList());
  }

  /**
   * Opens the project deletion confirm modal
   * @param projectId
   */
  openDeleteConfirm(projectId, projectName) {
    this.setState({
      deleteConfirmOpen: true,
      projectIdToDelete: projectId,
      projectNameToDelete: projectName
    });
  }

  /**
   * Deletes a project
   */
  deleteProject() {
    this.props.dispatch(deleteProject(this.state.projectIdToDelete));

    this.setState({
      deleteConfirmOpen: false,
      projectIdToDelete: null,
      projectNameToDelete: ''
    });
  }

  /**
   * Cancel confirm handler
   */
  handleDeleteCancel() {
    this.setState({
      deleteConfirmOpen: false,
      projectIdToDelete: null,
      projectNameToDelete: ''
    });
  }

  render() {
    return [
      <Grid key={0}>
        <Grid.Row className="five column project-featured-top">
          <Grid.Column className="left floated">
            <h1 className="page-title">Projects list</h1>
          </Grid.Column>

          <Grid.Column className="right floated">
            <Link className="add-new-project-link" to="/projects/new">
              <Button className="green">Add project</Button>
            </Link>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <ProjectsTable deleteHandler={this.openDeleteConfirm} path={this.props.match.path} />
            <ProjectsPagination />
          </Grid.Column>
        </Grid.Row>
      </Grid>,
      <Confirm
        key={1}
        open={this.state.deleteConfirmOpen}
        cancelButton="Cancel"
        confirmButton="Delete"
        content={`Delete project ${this.state.projectNameToDelete} ?`}
        onCancel={this.handleDeleteCancel}
        onConfirm={this.deleteProject}
      />
    ];
  }
}

export default connect()(List);



// WEBPACK FOOTER //
// ./src/scenes/projects/containers/List.js